export default __webpack_public_path__ + "static/media/TT Norms Pro Medium.a3dc2d38.otf";